import { Component, Input, OnInit } from '@angular/core';
import { TabViewModule } from '@primeng/tabview';
import {
  SelectAssignRenterComponent
} from '@modules/universal-billing/apartments/apartment-profile/renter-information/renter-assign/components/select-assign-renter/select-assign-renter.component';
import {
  CreateAssignRenterComponent
} from '@modules/universal-billing/apartments/apartment-profile/renter-information/renter-assign/components/create-assign-renter/create-assign-renter.component';
import { Apartment } from '@modules/universal-billing/apartments/apartments.interface';
import {TranslatePipe} from "@ngx-translate/core";

@Component({
  selector: 'app-renter-assign',
  standalone: true,
    imports: [
        TabViewModule,
        SelectAssignRenterComponent,
        CreateAssignRenterComponent,
        TranslatePipe
    ],
  templateUrl: './renter-assign.component.html',
  styleUrl: './renter-assign.component.scss'
})
export class RenterAssignComponent {
  @Input() apartment: Apartment;
}
